module.exports = __webpack_public_path__ + "static/media/Group 84 (1).957e884e.png";